"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipeGenerator_warehouseAndHallWay_V2 = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
const pipeResultV2_1 = require("./pipeResultV2");
const pipeCommonUtil_1 = require("./util/pipeCommonUtil");
const boundingBox_1 = require("../boundingBox");
const pipeNodeGroup_1 = require("./pipeNodeGroup");
const pipeNode_1 = require("./pipeNode");
const xGroup_1 = require("./xGroup");
const pipePointGroup_1 = require("./pipePointGroup");
const childPointAdjustUtil_1 = require("./util/childPointAdjustUtil");
class PointGroup {
    constructor(mainPoint, childPoints) {
        this._mainPoint = mainPoint;
        this._childPoints = childPoints;
    }
}
class PipeGenerator_warehouseAndHallWay_V2 {
    generate(points, blankDis, minDisToWall, minDisBetweenSprinklers, mainPipesInRoom, polygonSegs, polygon, coordinateUtil) {
        let points_local = new Array();
        for (let point of points) {
            let point_local = coordinateUtil.transformPointToLocal(point);
            points_local.push(new Coordinate_js_1.default(point_local.x, point_local.y));
        }
        let boundingBox = new boundingBox_1.BoundingBox(points_local);
        let lengthX = boundingBox.getLengthX();
        let lengthY = boundingBox.getLengthY();
        //计算X坐标
        let xArr = pipeCommonUtil_1.PipeCommonUtil.computeCoordArrV2(lengthX, boundingBox.min.x, boundingBox.max.x, blankDis);
        //计算Y坐标
        let yArr = pipeCommonUtil_1.PipeCommonUtil.computeCoordArrV2(lengthY, boundingBox.min.y, boundingBox.max.y, blankDis);
        //多边形的边也转到局部坐标系下
        let polygonSegs_local = coordinateUtil.transformLineSegmentArrayToLocal(polygonSegs);
        let polygon_local = coordinateUtil.transformPolygonToLocal(polygon);
        //仓库和走廊的方式和普通房间不同，比较复杂，先生成管点，再想办法凑主管线
        //TODO：化简一下这些Group的结构，不然看着太复杂了
        let adjustResult = new childPointAdjustUtil_1.ChildPointAdjustUtil().execute(xArr, yArr, polygonSegs_local, blankDis, minDisToWall, minDisBetweenSprinklers, polygon_local, boundingBox);
        yArr = [];
        let xArrGroups = new Array();
        for (let yToXArr of adjustResult.yToXArr_map) {
            yArr.push(yToXArr._y);
            xArrGroups.push(yToXArr._xArrGroup);
        }
        //判断是否为走廊，尝试去掉走廊的点
        this.handleHallway(yArr, xArrGroups, blankDis, polygonSegs_local, boundingBox);
        let originPoints = [];
        let adjustedPoints = [];
        //对单行的管点进行调整，调整到走廊中间
        let rowAdjust = true;
        if (rowAdjust) {
            for (let i = 0; i < yArr.length; i++) {
                let xArrGroup = xArrGroups[i];
                let aloneXArr = new Array();
                let y = yArr[i];
                //获取邻近的行
                let nearYArrIndices = pipeCommonUtil_1.PipeCommonUtil.findNearYArrIndices(i, yArr, blankDis);
                for (let xArr of xArrGroup) {
                    for (let x of xArr) {
                        let isAlone = true;
                        for (let nearYIndex of nearYArrIndices) {
                            //判断邻近行中是否有X值相近的点
                            if (pipeCommonUtil_1.PipeCommonUtil.findValueInGroup(x, xArrGroups[nearYIndex]) === true) {
                                isAlone = false;
                                break;
                            }
                        }
                        if (isAlone === true) {
                            aloneXArr.push(x);
                        }
                    }
                }
                //通过计算独立点占的比例来判断是否需要调整
                let aloneXNumRatio = 0;
                if (aloneXArr.length > 1) { //为了减少误判，两个点或以上才进行调整
                    let totalNum = 0;
                    for (let xArr of xArrGroup) {
                        totalNum += xArr.length;
                    }
                    aloneXNumRatio = aloneXArr.length / totalNum;
                }
                if (aloneXNumRatio > 0.5) {
                    //下面计算一条中轴线，逐点计算，取最短的一段，然后计算线段中点作为中轴线的Y值
                    let lines = new Array();
                    for (let x of aloneXArr) {
                        let intersectPoints = new Array();
                        let seg = new LineSegment_js_1.default(x, boundingBox.min.y, x, boundingBox.max.y);
                        for (let polygonSeg of polygonSegs_local) {
                            let intersectPoint = seg.intersection(polygonSeg);
                            if (intersectPoint) {
                                intersectPoints.push(intersectPoint);
                            }
                        }
                        if (intersectPoints.length < 2) {
                            console.error("单行的走廊管点调整失败");
                            return null;
                        }
                        //排序，计算该点在哪一段上
                        intersectPoints.sort(function (a, b) { return a.y - b.y; });
                        for (let j = 0; j < intersectPoints.length - 1; j++) {
                            if (y > intersectPoints[j].y && y < intersectPoints[j + 1].y) {
                                lines.push(new LineSegment_js_1.default(intersectPoints[j], intersectPoints[j + 1]));
                                break;
                            }
                        }
                    }
                    for (let xArr of xArrGroup) {
                        for (let x of xArr) {
                            originPoints.push(new Coordinate_js_1.default(x, y));
                        }
                    }
                    //取长度值最多的一段
                    let mostLine = this.getMostLine(lines)[0];
                    let centerY = mostLine.midPoint().y;
                    //这里直接对整个XArrGroup组的Y值做调整，后续可能会有问题，导致不必要的调整
                    yArr[i] = centerY;
                    for (let j = adjustedPoints.length; j < originPoints.length; j++) {
                        adjustedPoints.push(new Coordinate_js_1.default(originPoints[j].x, centerY));
                    }
                }
            }
            //检查是否需要补点、移除点、调整点
            if (originPoints.length > 0) {
                this.supplyPointsAfterMoveRow(originPoints, adjustedPoints, yArr, xArrGroups, blankDis, polygon_local);
                this.removePointsAfterMoveRow(originPoints, adjustedPoints, yArr, xArrGroups, blankDis, polygonSegs_local);
            }
        }
        //单列调整待测试
        let colAdjust = true;
        if (colAdjust) {
            let alonePoint_alreadyHandled = [];
            function IsPointAlreadyHandled(point, alonePoint_alreadyHandled) {
                for (let ah_point of alonePoint_alreadyHandled) {
                    if (ah_point.equals2D(point)) {
                        return true;
                    }
                }
                return false;
            }
            //对单列的也需要调整一下
            for (let i = 0; i < yArr.length; i++) {
                let xArrGroup = xArrGroups[i];
                for (let xArr of xArrGroup) {
                    //找到单列的点
                    if (xArr.length == 1 && i < yArr.length - 1) {
                        let aloneX = xArr[0];
                        if (IsPointAlreadyHandled(new Coordinate_js_1.default(aloneX, yArr[i]), alonePoint_alreadyHandled)) {
                            continue;
                        }
                        let aloneXArrList = [xArr]; //将单列的xArr存起来，这样修改的时候才能修改原来数组里的值
                        let aloneYArr = [yArr[i]];
                        let previousAloneY = yArr[i];
                        for (let j = i + 1; j < yArr.length; j++) {
                            if (yArr[j] - previousAloneY > 2 * blankDis + 500) {
                                break;
                            }
                            let nextXArrGroup = xArrGroups[j];
                            for (let nextXArr of nextXArrGroup) {
                                if (nextXArr.length == 1 && Math.abs(nextXArr[0] - aloneX) < 500) {
                                    aloneXArrList.push(nextXArr);
                                    aloneYArr.push(yArr[j]);
                                    previousAloneY = yArr[j];
                                    break;
                                }
                            }
                        }
                        if (aloneXArrList.length > 1) { //同样也是两个点或以上才进行调整
                            //下面计算一条中轴线，逐点计算，取最短的一段，然后计算线段中点作为中轴线的Y值
                            let lines = new Array();
                            for (let k = 0; k < aloneXArrList.length; k++) {
                                let intersectPoints = new Array();
                                let seg = new LineSegment_js_1.default(boundingBox.min.x, aloneYArr[k], boundingBox.max.x, aloneYArr[k]);
                                for (let polygonSeg of polygonSegs_local) {
                                    let intersectPoint = seg.intersection(polygonSeg);
                                    if (intersectPoint) {
                                        intersectPoints.push(intersectPoint);
                                    }
                                }
                                if (intersectPoints.length < 2) {
                                    console.error("单列的走廊管点调整失败");
                                    return null;
                                }
                                //排序，计算该点在哪一段上
                                intersectPoints.sort(function (a, b) { return a.x - b.x; });
                                for (let j = 0; j < intersectPoints.length - 1; j++) {
                                    if (aloneX > intersectPoints[j].x && aloneX < intersectPoints[j + 1].x) {
                                        lines.push(new LineSegment_js_1.default(intersectPoints[j], intersectPoints[j + 1]));
                                        break;
                                    }
                                }
                            }
                            if (lines.length == 0)
                                continue;
                            lines.sort(function (a, b) { return a.getLength() - b.getLength(); });
                            let centerX = lines[0].midPoint().x;
                            //通过centerX来划分，计算出距离centerX最近的两端的值，再重新计算一个centerX
                            let lessValues = [];
                            let greaterValues = [];
                            for (let line of lines) {
                                if (line.p0.x < centerX)
                                    lessValues.push(line.p0.x);
                                else
                                    greaterValues.push(line.p0.x);
                                if (line.p1.x < centerX)
                                    lessValues.push(line.p1.x);
                                else
                                    greaterValues.push(line.p1.x);
                            }
                            let maxLessValue = Math.max(...lessValues);
                            let minGreaterValue = Math.min(...greaterValues);
                            centerX = (maxLessValue + minGreaterValue) / 2;
                            /*for (let aloneXArr of aloneXArrList) {
                                aloneXArr[0] = centerX;
                            }*/
                            for (let j = 0; j < aloneXArrList.length; j++) {
                                let aloneXArr = aloneXArrList[j];
                                //判断移过去后是否会和下一行的Y值差距小于1800，如果小于，则跳过
                                //if (j == aloneXArrList.length - 1 || aloneYArr[j + 1] - aloneYArr[j] >= 1800) {
                                aloneXArr[0] = centerX;
                                //}
                                //存储已经处理过的点
                                alonePoint_alreadyHandled.push(new Coordinate_js_1.default(aloneXArr[0], aloneYArr[j]));
                            }
                        }
                    }
                }
            }
        }
        //这里传入的mainPipesInRoom还是世界坐标，需要转到当地
        let mainPipesInRoom_local = new Array();
        for (let mainPipe of mainPipesInRoom) {
            mainPipesInRoom_local.push(coordinateUtil.transformLineSegmentToLocal(mainPipe));
        }
        let pipeNodeGroups = this.convertPointsToPipeNodeGroups(yArr, xArrGroups, mainPipesInRoom_local, blankDis, coordinateUtil);
        //转换到世界坐标
        for (let pipeNodeGroup of pipeNodeGroups) {
            for (let mainNode of pipeNodeGroup._mainPipeNodes) {
                mainNode._point = coordinateUtil.transformPointToWorld(mainNode._point);
            }
            for (let childNode of pipeNodeGroup._childPipeNodes) {
                childNode._point = coordinateUtil.transformPointToWorld(childNode._point);
            }
        }
        let pipeResult = new pipeResultV2_1.PipeResultV2(pipeNodeGroups, coordinateUtil);
        pipeResult._polygonSegsLocal = polygonSegs_local;
        return pipeResult;
    }
    //寻找邻近行的点，返回Y值
    findNearPoint(point, isMoveToAbove, yArr, xArrGroups, blankDis) {
        //根据调整的方向，调整yArr数组的顺序
        let copyYArr = yArr.concat();
        let copyXArrGroups = xArrGroups.concat();
        //如果是向上调整的，则从Y较大的这边开始遍历
        if (isMoveToAbove) {
            copyYArr.reverse();
            copyXArrGroups.reverse();
        }
        for (let i = 0; i < copyYArr.length; i++) {
            let y = copyYArr[i];
            if (y === point.y)
                continue;
            else if (!isMoveToAbove && y < point.y)
                continue;
            else if (isMoveToAbove && y > point.y)
                continue;
            if (Math.abs(y - point.y) > 2 * blankDis)
                continue;
            let xArrGroup = copyXArrGroups[i];
            for (let xArr of xArrGroup) {
                for (let x of xArr) {
                    if (Math.abs(x - point.x) < 500) { //x方向的偏差容差值设为500
                        return y;
                    }
                }
            }
        }
        return null;
    }
    //移动单行后看看是否需要补点
    supplyPointsAfterMoveRow(originPoints, adjustedPoints, yArr, xArrGroups, blankDis, polygon_local) {
        let pointLocator = new PointLocator_js_1.default();
        //计算补充的点
        let newPointsMap = new Map();
        for (let i = 0; i < originPoints.length; i++) {
            let originPoint = originPoints[i];
            let adjustedPoint = adjustedPoints[i];
            //判断一下是朝上移动还是朝下移动
            let isMoveToAbove = adjustedPoint.y > originPoint.y;
            //向上或者向下判断有无邻近的点
            let nearY = this.findNearPoint(originPoint, isMoveToAbove, yArr, xArrGroups, blankDis);
            if (nearY === null)
                continue;
            //找到邻近的点后，判断有没有超限，如果超限了就补个点
            if (Math.abs(adjustedPoint.y - nearY) > 2 * blankDis) {
                //TODO：如果插入点后距离小于1800，则需要调整下一列。但没想好怎么处理，先加个判断，如果插入前距离小于3600，则跳过
                if (Math.abs(adjustedPoint.y - nearY) < 3600) {
                    continue;
                }
                //这个newY可能要归到50上
                let newY = (adjustedPoint.y + nearY) / 2;
                if (Math.abs(newY - adjustedPoint.y) % 50 > 0.1) {
                    let dis = pipeCommonUtil_1.PipeCommonUtil.getFloorValueOfMultipleOf50(newY - adjustedPoint.y);
                    newY = adjustedPoint.y + dis;
                }
                if (pointLocator.locateInPolygon(new Coordinate_js_1.default(adjustedPoint.x, newY), polygon_local) === Location_js_1.default.INTERIOR) {
                    if (newPointsMap.has(newY)) {
                        newPointsMap.get(newY).push(adjustedPoint.x);
                    }
                    else {
                        newPointsMap.set(newY, [adjustedPoint.x]);
                    }
                }
            }
        }
        //将补充的点加入到数组中
        this.addPoint(newPointsMap, yArr, xArrGroups, blankDis);
    }
    removePointsAfterMoveRow(originPoints, adjustedPoints, yArr, xArrGroups, blankDis, polygonSegs_local) {
        //处理过近的点，有两种处理方式，一是移除，二是调整点至符合距离要求的位置
        //移除的条件是：过于靠近墙？
        //调整点貌似可以不调，因为一般近也不会太近？(最小距离为1.8米)
        //计算需要移除或调整的点
        let newPointsMap = new Map();
        for (let i = 0; i < originPoints.length; i++) {
            let originPoint = originPoints[i];
            let adjustedPoint = adjustedPoints[i];
            //判断一下是朝上移动还是朝下移动
            let isMoveToAbove = adjustedPoint.y > originPoint.y;
            //向上或者向下判断有无邻近的点
            let nearY = this.findNearPoint(adjustedPoint, !isMoveToAbove, yArr, xArrGroups, blankDis);
            if (nearY === null)
                continue;
            //得先判断一下该方向有没有墙
            let judgeSeg = new LineSegment_js_1.default(adjustedPoint.x, adjustedPoint.y, adjustedPoint.x, isMoveToAbove ? adjustedPoint.y + blankDis + 500 : adjustedPoint.y - blankDis - 500); //这里依然是500的容差
            let isIntersectsWithWall = false;
            for (let seg of polygonSegs_local) {
                let intersectPoint = judgeSeg.intersection(seg);
                if (intersectPoint) {
                    isIntersectsWithWall = true;
                    break;
                }
            }
            if (isIntersectsWithWall) { //有墙的情况
                this.removePoint(adjustedPoint.x, nearY, yArr, xArrGroups);
                continue;
            }
            //接下来有两种情况，需要用1.8米这个条件判断是否需要移除
            //(暂时先忽略这种情况)有墙，距离超过blank，但仍有可能两个喷头的距离小于1.8米；
            //没墙的情况，调整距离至1800处
            if (Math.abs(adjustedPoint.y - nearY) < 1800) {
                //先移除点，再将调整后的点加回去
                this.removePoint(adjustedPoint.x, nearY, yArr, xArrGroups);
                let newY;
                if (isMoveToAbove) {
                    newY = adjustedPoint.y + 1800;
                }
                else {
                    newY = adjustedPoint.y - 1800;
                }
                //判断补充的点是否与下一行的距离小于1800，是的话则需要调整，目前将其调整至两行的中点处
                let nextNearY = this.findNearPoint(new Coordinate_js_1.default(adjustedPoint.x, newY), !isMoveToAbove, yArr, xArrGroups, blankDis);
                if (nextNearY) {
                    if (Math.abs(newY - nextNearY) < 1800) {
                        this.removePoint(adjustedPoint.x, nextNearY, yArr, xArrGroups);
                        newY = (newY + nextNearY) / 2;
                        if (Math.abs(newY - adjustedPoint.y) % 50 > 0.1) {
                            let dis = pipeCommonUtil_1.PipeCommonUtil.getFloorValueOfMultipleOf50(newY - adjustedPoint.y);
                            newY = adjustedPoint.y + dis;
                        }
                    }
                }
                if (newPointsMap.has(newY)) {
                    newPointsMap.get(newY).push(adjustedPoint.x);
                }
                else {
                    newPointsMap.set(newY, [adjustedPoint.x]);
                }
            }
        }
        //将补充的点加入到数组中
        //TODO：添加完点之后貌似还要加个1.8米的判断，如果太小了得继续调整下一行
        this.addPoint(newPointsMap, yArr, xArrGroups, blankDis);
    }
    //将新增的点添加进组
    addPoint(newPointsMap, yArr, xArrGroups, blankDis) {
        for (let pair of newPointsMap) {
            let y = pair[0];
            let xArr = pair[1];
            let index = -1;
            for (let i = 0; i < yArr.length - 1; i++) {
                if (y > yArr[i] && y < yArr[i + 1]) {
                    index = i + 1;
                    yArr.splice(index, 0, y);
                    break;
                }
            }
            if (index < 0) //这种属于异常情况，放弃添加该行
                continue;
            let xArrGroup = new Array();
            for (let x of xArr) {
                if (xArrGroup.length == 0)
                    xArrGroup.push([x]);
                else {
                    let lastXArr = xArrGroup[xArrGroup.length - 1];
                    if (x - lastXArr[lastXArr.length - 1] < 2 * blankDis + 800) { //这个容差和普通的点分组一致
                        lastXArr.push(x);
                    }
                    else {
                        xArrGroup.push([x]);
                    }
                }
            }
            xArrGroups.splice(index, 0, xArrGroup);
        }
    }
    //移除某点
    removePoint(x, nearY, yArr, xArrGroups) {
        let index = yArr.indexOf(nearY);
        let xArrGroup = xArrGroups[index];
        for (let j = xArrGroup.length - 1; j >= 0; j--) {
            let xArr = xArrGroup[j];
            for (let k = xArr.length - 1; k >= 0; k--) {
                if (Math.abs(x - xArr[k]) < 500) { //这里的500是和findNearPoint里的相对应
                    xArr.splice(k, 1);
                    if (xArr.length == 0)
                        xArrGroup.splice(j, 1);
                }
            }
        }
        if (xArrGroup.length == 0) {
            xArrGroups.splice(index, 1);
            yArr.splice(index, 1);
        }
    }
    convertPointsToPipeNodeGroups(yArr, xArrGroups, mainPipesInRoom_local, blankDis, coordinateUtil) {
        let pipePointGroups = new Array();
        for (let i = 0; i < yArr.length; i++) {
            let y = yArr[i];
            let xArrGroup = xArrGroups[i];
            if (xArrGroup.length == 0)
                continue;
            for (let xArr of xArrGroup) {
                if (xArr.length == 0)
                    continue;
                if (xArr.length == 1) { //如果数量为1，则自成一组，并往下一行探，看看有没有同一列的
                    pipePointGroups.push(this.handleSingleRow(i, xArr[0], y, yArr, xArrGroups, blankDis));
                }
                else { //正常情况
                    pipePointGroups.push(this.handleMultiRow(i, xArr, yArr, xArrGroups, blankDis));
                }
            }
        }
        //移除空的数组
        for (let i = xArrGroups.length - 1; i >= 0; i--) {
            if (xArrGroups[i].length == 0) {
                xArrGroups.splice(i, 1);
                yArr.splice(i, 1);
            }
        }
        return this.convertPipePointGroupToNodes(pipePointGroups, mainPipesInRoom_local, coordinateUtil);
    }
    //单个管点或者单列
    handleSingleRow(i, x, y, yArr, xArrGroups, blankDis) {
        let points = [new Coordinate_js_1.default(x, y)];
        let singleColumnYArr = [y];
        for (let j = i + 1; j < yArr.length; j++) {
            let hasSingleColumn = false;
            let xArrGroup_next = xArrGroups[j];
            //距离太远的行就不相连了
            if (yArr[j] - singleColumnYArr[singleColumnYArr.length - 1] > 2 * blankDis + 500) { //这里的500阈值和单列调整时一致
                break;
            }
            else {
                singleColumnYArr.push(yArr[j]);
            }
            for (let k = xArrGroup_next.length - 1; k >= 0; k--) {
                let xArr_next = xArrGroup_next[k];
                if (xArr_next.length == 1 && xArr_next[0] == x) {
                    hasSingleColumn = true;
                    points.push(new Coordinate_js_1.default(xArr_next[0], yArr[j]));
                    xArrGroup_next.splice(k, 1);
                }
            }
            if (!hasSingleColumn) {
                break;
            }
        }
        return new pipePointGroup_1.PipePointGroup([points]);
    }
    //单行或多行管点
    handleMultiRow(i, xArr, yArr, xArrGroups, blankDis) {
        let pointsGroups = new Array();
        pointsGroups.push(new Array());
        for (let x of xArr) {
            pointsGroups[0].push(new Coordinate_js_1.default(x, yArr[i]));
        }
        let xGroup = new xGroup_1.XGroup(xArr);
        let finalXGroup = new xGroup_1.XGroup(xArr);
        let singleColumnYArr = [yArr[i]];
        //往下一行探探，看能不能合并成一组
        for (let j = i + 1; j < yArr.length; j++) {
            //距离太远的行就不相连了
            if (yArr[j] - singleColumnYArr[singleColumnYArr.length - 1] > 2 * blankDis + 500) { //这里的500阈值和单列调整时一致
                break;
            }
            else {
                singleColumnYArr.push(yArr[j]);
            }
            let canMerge = false;
            let xArrGroup_next = xArrGroups[j];
            for (let k = xArrGroup_next.length - 1; k >= 0; k--) {
                let xArr_next = xArrGroup_next[k];
                let xGroup_next = new xGroup_1.XGroup(xArr_next);
                if (xGroup.computeOverlapMinFactor(xGroup_next) > 0.9) { //重合比例大于0.9，则判断为合并
                    canMerge = true;
                    pointsGroups.push(new Array());
                    for (let x of xArr_next) {
                        pointsGroups[pointsGroups.length - 1].push(new Coordinate_js_1.default(x, yArr[j]));
                    }
                    xArrGroup_next.splice(k, 1);
                    finalXGroup.expandByOther(xGroup_next);
                }
            }
            if (!canMerge) {
                break;
            }
        }
        return new pipePointGroup_1.PipePointGroup(pointsGroups);
    }
    convertPipePointGroupToNodes(pipePointGroups, mainPipesInRoom_local, coordinateUtil) {
        let pipeNodeGroups = new Array();
        for (let pipePointGroup of pipePointGroups) {
            for (let points of pipePointGroup._pointsGroups) { //points为单行管点
                //只有一个点的情况
                if (points.length == 1) {
                    let pipeNodeGroup = new pipeNodeGroup_1.PipeNodeGroup([], []);
                    pipeNodeGroup._childPipeNodes.push(new pipeNode_1.PipeNode(points[0], pipeNode_1.PipeNodeType.Child));
                    pipeNodeGroups.push(pipeNodeGroup);
                }
                else {
                    let seg = new LineSegment_js_1.default(points[0], points[points.length - 1]);
                    let intersectPoints = new Array(); //交点可能不止一个，所以要用数组存储
                    for (let mainPipe of mainPipesInRoom_local) {
                        let intersectPoint = seg.intersection(mainPipe);
                        if (intersectPoint) {
                            let existed = false;
                            for (let existedPoint of intersectPoints) {
                                if (existedPoint.equals2D(intersectPoint)) {
                                    existed = true;
                                    break;
                                }
                            }
                            if (!existed)
                                intersectPoints.push(intersectPoint);
                        }
                    }
                    let pointGroupArr = new Array();
                    if (intersectPoints.length == 0) { //无交点直接分组
                        this.handleNoIntersectPoints(points, pointGroupArr);
                    }
                    else {
                        //计算交点在哪个位置
                        let map_intersectPoint_indexOfPolyline = new Map();
                        for (let i = 0; i < intersectPoints.length; i++) {
                            map_intersectPoint_indexOfPolyline.set(intersectPoints[i], this.computeWhichPartOfLine(points, intersectPoints[i]));
                        }
                        let arr_intersectPoint_indexOfPolyline = Array.from(map_intersectPoint_indexOfPolyline);
                        //按与第一个喷头的距离排序
                        arr_intersectPoint_indexOfPolyline.sort(function (a, b) { return a[0].distance(points[0]) - b[0].distance(points[0]); });
                        //交点也从小到大排序
                        intersectPoints.sort(function (a, b) { return a.distance(points[0]) - b.distance(points[0]); });
                        //将整段线的点分为三部分：1.第一个交点前；2.交点中间；3.最后一个交点后
                        let frontArr = new Array();
                        let backArr = new Array();
                        let minIndex = arr_intersectPoint_indexOfPolyline[0][1];
                        let maxIndex = arr_intersectPoint_indexOfPolyline[arr_intersectPoint_indexOfPolyline.length - 1][1];
                        for (let i = 0; i < points.length; i++) {
                            if (i <= minIndex)
                                frontArr.push(i);
                            else if (i > maxIndex)
                                backArr.push(i);
                        }
                        //处理起点
                        this.handleFrontPart(frontArr, intersectPoints[0], points, minIndex, pointGroupArr);
                        //处理中间的点，处理时需要将点再细分到两个点中间
                        this.handleMiddlePart(arr_intersectPoint_indexOfPolyline, points, intersectPoints, pointGroupArr);
                        //处理终点
                        this.handleBackPart(backArr, intersectPoints[intersectPoints.length - 1], points, pointGroupArr);
                    }
                    pipeNodeGroups = pipeNodeGroups.concat(this.convertPointGroupToNodeGroup(pointGroupArr));
                }
            }
        }
        return pipeNodeGroups;
    }
    computeWhichPartOfLine(points, point) {
        for (let i = 0; i < points.length - 1; i++) {
            let segment = new LineSegment_js_1.default(points[i], points[i + 1]);
            let projFac = segment.projectionFactor(point);
            if (projFac >= 0 && projFac <= 1) {
                return i;
            }
        }
        return -1;
    }
    addToPointGroupArr(newPointGroup, pointGroupArr) {
        for (let pointGroup of pointGroupArr) {
            if (pointGroup._mainPoint && pointGroup._mainPoint == newPointGroup._mainPoint) {
                pointGroup._childPoints = pointGroup._childPoints.concat(newPointGroup._childPoints);
                return;
            }
        }
        pointGroupArr.push(newPointGroup);
    }
    //处理起点
    handleFrontPart(frontArr, firstIntersectPoint, points, minIndex, pointGroupArr) {
        let pointCount = frontArr.length;
        if (pointCount <= 8) { //小于等于8个点则不需要额外增加点
            let mainPoint = firstIntersectPoint;
            let childPoints = new Array();
            for (let index of frontArr) {
                childPoints.push(points[index]);
            }
            pointGroupArr.push(new PointGroup(mainPoint, childPoints));
        }
        else { //大于8个点，则按16个点为一组，分割
            //最右边的8个点分给第一个交点
            let mainPoint = firstIntersectPoint;
            let childPoints = new Array();
            for (let i = pointCount - 8; i < pointCount; i++) {
                childPoints.push(points[i]);
            }
            pointGroupArr.push(new PointGroup(mainPoint, childPoints));
            //剩下的
            let leftPointCount = pointCount - 8;
            let groupNum = Math.ceil(leftPointCount / 16);
            for (let i = 0; i < groupNum; i++) {
                let childPoints_group = new Array();
                for (let j = 0; j < 16 && j <= minIndex - 8; j++) {
                    childPoints_group.push(points[i * 16 + j]);
                }
                pointGroupArr.push(new PointGroup(null, childPoints_group));
            }
        }
    }
    //处理中间的点，处理时需要将点再细分到两个点中间
    handleMiddlePart(arr_intersectPoint_indexOfPolyline, points, intersectPoints, pointGroupArr) {
        //把点细分到交点中间，数组第0个表示处在第0个和第1个交点中间
        let middleIndicesArr = new Array();
        for (let i = 0; i < arr_intersectPoint_indexOfPolyline.length - 1; i++) {
            let index = arr_intersectPoint_indexOfPolyline[i][1];
            let nextIndex = arr_intersectPoint_indexOfPolyline[i + 1][1];
            if (nextIndex - index == 0)
                middleIndicesArr.push([]);
            else {
                let indices = new Array();
                for (let i = index + 1; i <= nextIndex; i++) {
                    indices.push(i);
                }
                middleIndicesArr.push(indices);
            }
        }
        for (let i = 0; i < middleIndicesArr.length; i++) {
            let indices = middleIndicesArr[i];
            if (indices.length == 0)
                continue;
            else if (indices.length <= 16) { //小于等于16个点，则均分为两边
                let splitIndex = Math.ceil(indices.length / 2);
                let childPoints_front = new Array();
                for (let j = 0; j < splitIndex; j++) {
                    childPoints_front.push(points[indices[j]]);
                }
                this.addToPointGroupArr(new PointGroup(intersectPoints[i], childPoints_front), pointGroupArr);
                if (indices.length == 1) //若indices的数量为1，则没有点分配给后面了，跳过
                    continue;
                let childPoints_back = new Array();
                for (let j = splitIndex; j < indices.length; j++) {
                    childPoints_back.push(points[indices[j]]);
                }
                this.addToPointGroupArr(new PointGroup(intersectPoints[i + 1], childPoints_back), pointGroupArr);
            }
            else { //大于16点的情况，减去16个点后，分组
                //0-7分给前面的点
                let childPoints_front = new Array();
                for (let j = 0; j < 8; j++) {
                    childPoints_front.push(points[indices[j]]);
                }
                this.addToPointGroupArr(new PointGroup(intersectPoints[i], childPoints_front), pointGroupArr);
                //中间8~indices.length-9的点分组
                let leftPointCount = indices.length - 16;
                let groupNum = Math.ceil(leftPointCount / 16);
                for (let j = 0; j < groupNum; j++) {
                    let childPoints = new Array();
                    let minIndex = 8 + (groupNum - 1) * 16;
                    let maxIndex = Math.min(minIndex + 16, indices.length - 8);
                    for (let k = minIndex; k < maxIndex; k++) {
                        childPoints.push(points[indices[k]]);
                    }
                    pointGroupArr.push(new PointGroup(null, childPoints));
                }
                //indices.length-8~indices.length-1分给后面的点
                let childPoints_back = new Array();
                for (let j = indices.length - 8; j < indices.length; j++) {
                    childPoints_back.push(points[indices[j]]);
                }
                this.addToPointGroupArr(new PointGroup(intersectPoints[i + 1], childPoints_back), pointGroupArr);
            }
        }
    }
    handleNoIntersectPoints(points, pointGroupArr) {
        let groupNum = Math.ceil(points.length / 16);
        for (let i = 0; i < groupNum; i++) {
            let childPoints = new Array();
            for (let j = 0; j < 16 && (i * 16 + j) < points.length; j++) {
                childPoints.push(points[i * 16 + j]);
            }
            pointGroupArr.push(new PointGroup(null, childPoints));
        }
    }
    //处理终点
    handleBackPart(backArr, lastIntersectPoint, points, pointGroupArr) {
        let pointCount = backArr.length;
        if (pointCount <= 8) { //小于等于8个点则不需要额外增加点
            let mainPoint = lastIntersectPoint;
            let childPoints = new Array();
            for (let index of backArr) {
                childPoints.push(points[index]);
            }
            this.addToPointGroupArr(new PointGroup(mainPoint, childPoints), pointGroupArr);
        }
        else { //大于8个点，则按16个点为一组，分割
            let mainPoint = lastIntersectPoint;
            let childPoints = new Array();
            for (let i = 0; i < 8; i++) {
                childPoints.push(points[backArr[i]]);
            }
            this.addToPointGroupArr(new PointGroup(mainPoint, childPoints), pointGroupArr);
            //剩下的
            let leftPointCount = pointCount - 8;
            let groupNum = Math.ceil(leftPointCount / 16);
            for (let i = 0; i < groupNum; i++) {
                let childPoints_group = new Array();
                for (let j = 0; j < 16 && j < leftPointCount - i * 16; j++) {
                    childPoints_group.push(points[backArr[8 + i * 16 + j]]);
                }
                pointGroupArr.push(new PointGroup(null, childPoints_group));
            }
        }
    }
    //坐标点组转换为有父子关系的节点组
    convertPointGroupToNodeGroup(pointGroupArr) {
        //两种情况：点组中带主管点的、不带主管点的
        let pipeNodeGroupArr = new Array();
        for (let pointGroup of pointGroupArr) {
            let boundingBox = new boundingBox_1.BoundingBox(pointGroup._childPoints);
            //判断是横向的还是纵向的，然后保险点，排个序（虽然添加进去的过程貌似已经是按顺序的了）
            let isHorizontal = boundingBox.getLengthX() > boundingBox.getLengthY();
            if (isHorizontal)
                pointGroup._childPoints.sort(function (a, b) { return a.x - b.x; });
            else
                pointGroup._childPoints.sort(function (a, b) { return a.y - b.y; });
            let pipeNodeGroup = new pipeNodeGroup_1.PipeNodeGroup([], []);
            let mainPoint = pointGroup._mainPoint;
            if (mainPoint) { //带主管点的
                let frontPoints = new Array();
                let backPoints = new Array();
                for (let point of pointGroup._childPoints) {
                    if (isHorizontal) {
                        if (point.x < mainPoint.x)
                            frontPoints.push(point);
                        else
                            backPoints.push(point);
                    }
                    else {
                        if (point.y < mainPoint.y)
                            frontPoints.push(point);
                        else
                            backPoints.push(point);
                    }
                }
                frontPoints.reverse();
                let mainNode = new pipeNode_1.PipeNode(mainPoint, pipeNode_1.PipeNodeType.Main);
                let previousNode = mainNode;
                pipeNodeGroup._mainPipeNodes.push(mainNode);
                for (let point of frontPoints) {
                    let childNode = new pipeNode_1.PipeNode(point, pipeNode_1.PipeNodeType.Child);
                    pipeNodeGroup._childPipeNodes.push(childNode);
                    previousNode.addChildNode(childNode);
                    previousNode = childNode;
                }
                previousNode = mainNode;
                for (let point of backPoints) {
                    let childNode = new pipeNode_1.PipeNode(point, pipeNode_1.PipeNodeType.Child);
                    pipeNodeGroup._childPipeNodes.push(childNode);
                    previousNode.addChildNode(childNode);
                    previousNode = childNode;
                }
            }
            else { //不带主管点的
                //只有一个点的情况则不生成主管点
                if (pointGroup._childPoints.length == 1) {
                    pipeNodeGroup._childPipeNodes.push(new pipeNode_1.PipeNode(pointGroup._childPoints[0], pipeNode_1.PipeNodeType.Child));
                }
                else {
                    let mainNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(boundingBox.getCenter().x, boundingBox.getCenter().y), pipeNode_1.PipeNodeType.Main);
                    pipeNodeGroup._mainPipeNodes.push(mainNode);
                    //let overlapWithChildPoint = false;
                    let overlappedChildPoint = undefined;
                    for (let point of pointGroup._childPoints) {
                        if (mainNode._point.equals2D(point, 200)) {
                            //overlapWithChildPoint = true;
                            overlappedChildPoint = point;
                            break;
                        }
                    }
                    let frontPoints = new Array();
                    let backPoints = new Array();
                    if (isHorizontal) {
                        if (overlappedChildPoint) {
                            //mainNode._point.x += 600;
                            mainNode._point = new Coordinate_js_1.default(overlappedChildPoint.x + 600, overlappedChildPoint.y);
                        }
                        for (let point of pointGroup._childPoints) {
                            if (point.x < mainNode._point.x)
                                frontPoints.push(point);
                            else
                                backPoints.push(point);
                        }
                    }
                    else {
                        if (overlappedChildPoint) {
                            //mainNode._point.y += 600;
                            mainNode._point = new Coordinate_js_1.default(overlappedChildPoint.x, overlappedChildPoint.y + 600);
                        }
                        for (let point of pointGroup._childPoints) {
                            if (point.y < mainNode._point.y)
                                frontPoints.push(point);
                            else
                                backPoints.push(point);
                        }
                    }
                    frontPoints.reverse();
                    let previousNode = mainNode;
                    for (let child of frontPoints) {
                        let node = new pipeNode_1.PipeNode(child, pipeNode_1.PipeNodeType.Child);
                        pipeNodeGroup._childPipeNodes.push(node);
                        previousNode.addChildNode(node);
                        previousNode = node;
                    }
                    previousNode = mainNode;
                    for (let child of backPoints) {
                        let node = new pipeNode_1.PipeNode(child, pipeNode_1.PipeNodeType.Child);
                        pipeNodeGroup._childPipeNodes.push(node);
                        previousNode.addChildNode(node);
                        previousNode = node;
                    }
                }
            }
            pipeNodeGroupArr.push(pipeNodeGroup);
        }
        return pipeNodeGroupArr;
    }
    handleHallway(yArr, xArrGroups, blankDis, polygonSegs_local, boundingBox) {
        for (let i = 0; i < yArr.length - 1; i++) {
            let y = yArr[i];
            let xArrGroup = xArrGroups[i];
            //获取邻近的行
            let nearYArrIndices = pipeCommonUtil_1.PipeCommonUtil.findNearYArrIndices(i, yArr, blankDis);
            for (let xArr of xArrGroup) {
                for (let j = xArr.length - 1; j >= 0; j--) {
                    for (let nearYIndex of nearYArrIndices) {
                        //判断邻近行中是否有X值相近的点，有的话就移除自身
                        if (pipeCommonUtil_1.PipeCommonUtil.findValueInGroup_V2(xArr[j], y, xArrGroups[nearYIndex], yArr[nearYIndex], polygonSegs_local) === true) {
                            if (this.checkIfOneSprinkerEnough(y, xArr[j], blankDis, polygonSegs_local, boundingBox)) {
                                xArr.splice(j, 1);
                            }
                            break;
                        }
                    }
                }
            }
        }
    }
    checkIfOneSprinkerEnough(newY, x, blankDis, polygonSegs_local, boundingBox) {
        let targetSeg = new LineSegment_js_1.default(x, boundingBox.min.y, x, boundingBox.max.y);
        let intersectPoints = [];
        for (let seg of polygonSegs_local) {
            let intersectPoint = targetSeg.intersection(seg);
            if (intersectPoint && !intersectPoint.equals2D(seg.p0, 1) && !intersectPoint.equals2D(seg.p1, 1)) {
                intersectPoints.push(intersectPoint);
            }
        }
        //分为两组
        let underYArr = [];
        let aboveYArr = [];
        for (let point of intersectPoints) {
            if (point.y < newY)
                underYArr.push(point.y);
            else
                aboveYArr.push(point.y);
        }
        let maxY_under = Math.max(...underYArr);
        let minY_above = Math.min(...aboveYArr);
        let distance = minY_above - maxY_under;
        //如果两个Y值得差值太小，则判断为不是横向走廊，不进行移除
        if (distance < blankDis + 500) {
            return false;
        }
        //如果这两个Y值的差值小于阈值，则该X值认定为无效补充值，移除
        return distance < 2 * blankDis + 500; //加个500是为了增加容错。一般的门内陷的长度是100或120，理论上来说这个500的值偏大了，可能会造成某些问题
    }
    getMostLine(lines) {
        lines.sort(function (a, b) { return a.getLength() - b.getLength(); });
        let lineGroups = new Array();
        for (let line of lines) {
            if (lineGroups.length == 0) {
                lineGroups.push([line]);
            }
            let lastLineGroup = lineGroups[lineGroups.length - 1];
            //小于阈值的划分到同一个组
            if (Math.abs(lastLineGroup[lastLineGroup.length - 1].getLength() - line.getLength()) < 10) {
                lastLineGroup.push(line);
            }
            else {
                lineGroups.push([line]);
            }
        }
        lineGroups.sort(function (a, b) { return b.length - a.length; });
        return lineGroups[0];
    }
}
exports.PipeGenerator_warehouseAndHallWay_V2 = PipeGenerator_warehouseAndHallWay_V2;
